import {
  MONUMPAY_WITHDRAWAL_REQUEST,
  MONUMPAY_WITHDRAWAL_REQUEST_SUCCESS,
  MONUMPAY_WITHDRAWAL_REQUEST_FAILURE,
} from "../actionTypes";

export const momumpayWithdrawalRequest = (payload) => ({
  type: MONUMPAY_WITHDRAWAL_REQUEST,
  payload,
});

export const momumpayWithdrawalRequestSuccess = (payload) => ({
  type: MONUMPAY_WITHDRAWAL_REQUEST_SUCCESS,
  payload,
});

export const momumpayWithdrawalRequestFailure = () => ({
  type: MONUMPAY_WITHDRAWAL_REQUEST_FAILURE,
});
